import * as React from "react"
import { IconButton } from "../buttons/icon-button"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { CloseOverlayIconProps } from "./types"
import { Flex } from "@chakra-ui/react"
import { showBadgeOverlayAtom } from "../../../recoil/atoms/overlay"
import { brandingSelector } from "../../../recoil/atoms/room"
import { Icon } from "./icon"
import { IoClose } from "react-icons/io5"

const _CloseOverlayIcon: React.FC<CloseOverlayIconProps> = ({ isMobile }) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const setEnabledOverlay = useSetRecoilState(showBadgeOverlayAtom)

  const handleCloseOverlay = e => {
    setEnabledOverlay(false)
    e.stopPropagation()
  }

  return (
    <IconButton
      pos="absolute"
      width="19px"
      height="19px"
      right={"4px"}
      top={"4px"}
      isMobile={isMobile}
      onClick={handleCloseOverlay}
    >
      <Flex
        width="19px"
        height="19px"
        borderRadius="50%"
        alignItems="center"
        justifyContent="center"
        textColor={roomStyles?.badgeCloseButtonTextColor ?? "#718096"}
        cursor={"pointer"}
        zIndex={1}
      >
        <Icon
          src={IoClose}
          fontSize="1rem"
          marginRight="-50%"
          transform="translate(-50%, -50%)"
          top="50%"
          left="50%"
          pos="absolute"
        />
      </Flex>
    </IconButton>
  )
}

export const CloseOverlayIcon = React.memo(_CloseOverlayIcon)
